import React from "react"
import { complementAdresseToListString } from "../../utilities/Addons"
import { ENTITE_TYPES, ENTITE_TYPES_DICT } from "../dashboard/entite/Entite"

export const PersonnePhysiqueCard = ({
	entite,
	updateEntite = null,
	title = "Informations client",
	adresse = null,
	showDetails = false,
	showExtraDatas = false,
}) => {
	return (
		<div style={styles.card}>
			<div style={styles.cardTitle}>{title}</div>
			<div style={styles.fieldGroup}>
				<Field label={"Nom"}>
					<input
						type={"text"}
						value={entite.nom}
						style={styles.input}
						{...(updateEntite
							? {
									onChange: (e) =>
										updateEntite("nom")(e.target.value),
								}
							: { readOnly: true })}
					/>
				</Field>
				<Field label={"Prénom"}>
					<input
						type={"text"}
						value={entite.prenom}
						style={styles.input}
						{...(updateEntite
							? {
									onChange: (e) =>
										updateEntite("prenom")(e.target.value),
								}
							: { readOnly: true })}
					/>
				</Field>
				<Field label={"Téléphone"}>
					<input
						type={"text"}
						value={entite.telephone}
						style={styles.input}
						{...(updateEntite
							? {
									onChange: (e) =>
										updateEntite("telephone")(
											e.target.value,
										),
								}
							: { readOnly: true })}
					/>
				</Field>
				<Field label={"E-mail"}>
					<input
						type={"text"}
						value={entite.email}
						style={styles.input}
						{...(updateEntite
							? {
									onChange: (e) =>
										updateEntite("email")(e.target.value),
								}
							: { readOnly: true })}
					/>
				</Field>
				{adresse && (
					<>
						<Field label={"Adresse"}>
							<input
								type={"text"}
								value={
									complementAdresseToListString(adresse)[0]
								}
								style={styles.input}
								readOnly={true}
							/>
						</Field>
						<Field label={""}>
							<input
								type={"text"}
								value={
									complementAdresseToListString(adresse)[1]
								}
								style={styles.input}
								readOnly={true}
							/>
						</Field>
					</>
				)}
				{showDetails && (
					<>
						<Field label={"Date de naissance"}>
							<input
								type={"date"}
								value={entite.date_naissance}
								style={styles.input}
								{...(updateEntite
									? {
											onChange: (_) =>
												updateEntite("date_naissance"),
										}
									: { readOnly: true })}
							/>
						</Field>
						<Field label={"Permis"}>
							<input
								type={"text"}
								value={entite.permis}
								style={styles.input}
								{...(updateEntite
									? {
											onChange: (e) =>
												updateEntite("permis")(
													e.target.value,
												),
										}
									: { readOnly: true })}
							/>
						</Field>
						<Field label={"Numéro permis"}>
							<input
								type={"text"}
								value={entite.numero_permis}
								style={styles.input}
								{...(updateEntite
									? {
											onChange: (e) =>
												updateEntite("numero_permis")(
													e.target.value,
												),
										}
									: { readOnly: true })}
							/>
						</Field>
						<Field label={"Date d'obtention"}>
							<input
								type={"date"}
								value={entite.date_obtention_permis}
								style={styles.input}
								{...(updateEntite
									? {
											onChange: (_) =>
												updateEntite(
													"date_obtention_permis",
												),
										}
									: { readOnly: true })}
							/>
						</Field>
					</>
				)}
			</div>
		</div>
	)
}
export const EntiteCard = ({
	entite,
	updateEntite = null,
	title = "Informations client",
	adresse = null,
	showDetails = false,
	showExtraDatas = false,
}) => {
	return (
		<div style={styles.card}>
			<div style={styles.cardTitle}>{title}</div>
			<div style={styles.fieldGroup}>
				<Field label={"Type"}>
					{updateEntite ? (
						<select
							value={entite.type}
							style={styles.select}
							{...(updateEntite
								? {
										onChange: (e) =>
											updateEntite("type")(
												parseInt(e.target.value),
											),
									}
								: { readOnly: true })}
						>
							{ENTITE_TYPES.map((et, i) => (
								<option key={`entite_type_${i}`} value={et[0]}>
									{et[1]}
								</option>
							))}
						</select>
					) : (
						<input
							type={"text"}
							value={ENTITE_TYPES_DICT[entite.type]}
							style={styles.input}
							readOnly={true}
						/>
					)}
				</Field>
				<Field label={"Label"}>
					<input
						type={"text"}
						value={entite.label}
						style={styles.input}
						{...(updateEntite
							? {
									onChange: (e) =>
										updateEntite("label")(e.target.value),
								}
							: { readOnly: true })}
					/>
				</Field>
				<Field label={"Téléphone"}>
					<input
						type={"text"}
						value={entite.telephone}
						style={styles.input}
						{...(updateEntite
							? {
									onChange: (e) =>
										updateEntite("telephone")(
											e.target.value,
										),
								}
							: { readOnly: true })}
					/>
				</Field>
				<Field label={"E-mail"}>
					<input
						type={"text"}
						value={entite.email}
						style={styles.input}
						{...(updateEntite
							? {
									onChange: (e) =>
										updateEntite("email")(e.target.value),
								}
							: { readOnly: true })}
					/>
				</Field>
				{adresse && (
					<>
						<Field label={"Adresse"}>
							<input
								type={"text"}
								value={
									complementAdresseToListString(adresse)[0]
								}
								style={styles.input}
								readOnly={true}
							/>
						</Field>
						<Field label={""}>
							<input
								type={"text"}
								value={
									complementAdresseToListString(adresse)[1]
								}
								style={styles.input}
								readOnly={true}
							/>
						</Field>
					</>
				)}
			</div>
		</div>
	)
}

export const FieldColumn = ({ label, children, style }) => (
	<div style={{ display: "flex", flexDirection: "column", gap: 4, ...style }}>
		<label
			style={{
				fontSize: 11,
				fontWeight: 500,
				color: COLORS.textLight,
				textTransform: "uppercase",
				letterSpacing: "0.06em",
			}}
		>
			{label}
		</label>
		{children}
	</div>
)

export const Field = ({ label, children }) => (
	<div style={styles.fieldRow}>
		<span style={styles.label}>{label}</span>
		{children}
	</div>
)

const COLORS = {
	bg: "#F5F3EF",
	surface: "#FFFFFF",
	border: "#E2DDD6",
	borderStrong: "#C8C0B4",
	text: "#1C1917",
	textMuted: "#78716C",
	textLight: "#A8A29E",
	accent: "#2563EB",
	accentLight: "#EFF6FF",
	danger: "#DC2626",
	success: "#16A34A",
	successLight: "#F0FDF4",
	warning: "#D97706",
	warningLight: "#FFFBEB",
	gold: "#B45309",
}

const styles = {
	header: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		marginBottom: 32,
	},
	ficheNumber: {
		fontSize: 12,
		fontWeight: 500,
		color: COLORS.textLight,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		marginBottom: 4,
	},
	title: {
		fontSize: 26,
		fontWeight: 600,
		color: COLORS.text,
		letterSpacing: "-0.02em",
	},
	badge: (color, bg) => ({
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
		padding: "6px 14px",
		borderRadius: 99,
		fontSize: 13,
		fontWeight: 500,
		color,
		backgroundColor: bg,
	}),
	grid3: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		gap: 16,
		marginBottom: 16,
	},
	grid2: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		gap: 16,
		marginBottom: 16,
	},
	card: {
		backgroundColor: COLORS.surface,
		borderRadius: 16,
		border: `1px solid ${COLORS.border}`,
		padding: "20px 24px",
		boxSizing: "border-box",
	},
	cardTitle: {
		fontSize: 11,
		fontWeight: 600,
		color: COLORS.textLight,
		letterSpacing: "0.1em",
		textTransform: "uppercase",
		marginBottom: 18,
		paddingBottom: 12,
		borderBottom: `1px solid ${COLORS.border}`,
	},
	fieldGroup: {
		display: "flex",
		flexDirection: "column",
		gap: 12,
	},
	fieldRow: {
		display: "flex",
		alignItems: "center",
		gap: 8,
	},
	label: {
		fontSize: 12,
		fontWeight: 500,
		color: COLORS.textMuted,
		minWidth: 130,
		flexShrink: 0,
	},
	input: {
		flex: 1,
		padding: "7px 11px",
		border: `1px solid ${COLORS.border}`,
		borderRadius: 8,
		fontSize: 13,
		color: COLORS.text,
		backgroundColor: COLORS.surface,
		outline: "none",
		fontFamily: "inherit",
		transition: "border-color 0.15s",
		boxSizing: "border-box",
	},
	inputReadonly: {
		flex: 1,
		padding: "7px 11px",
		border: `1px solid ${COLORS.border}`,
		borderRadius: 8,
		fontSize: 13,
		color: COLORS.text,
		backgroundColor: "#FAFAF9",
		fontFamily: "inherit",
		boxSizing: "border-box",
	},
	select: {
		flex: 1,
		padding: "7px 11px",
		border: `1px solid ${COLORS.border}`,
		borderRadius: 8,
		fontSize: 13,
		color: COLORS.text,
		backgroundColor: COLORS.surface,
		outline: "none",
		fontFamily: "inherit",
		cursor: "pointer",
		boxSizing: "border-box",
	},
	splitInput: {
		display: "flex",
		gap: 6,
		flex: 1,
	},
	statCard: {
		backgroundColor: COLORS.surface,
		border: `1px solid ${COLORS.border}`,
		borderRadius: 12,
		padding: "14px 18px",
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	statLabel: {
		fontSize: 11,
		fontWeight: 500,
		color: COLORS.textLight,
		textTransform: "uppercase",
		letterSpacing: "0.06em",
	},
	statValue: {
		fontSize: 22,
		fontWeight: 600,
		color: COLORS.text,
		letterSpacing: "-0.02em",
	},
	statSub: {
		fontSize: 11,
		color: COLORS.textMuted,
	},
	totalHighlight: {
		backgroundColor: COLORS.text,
		border: `1px solid ${COLORS.text}`,
		borderRadius: 12,
		padding: "14px 18px",
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	conducteurCard: {
		border: `1px solid ${COLORS.border}`,
		borderRadius: 12,
		padding: "16px",
		backgroundColor: COLORS.surface,
		position: "relative",
	},
	conducteurPrimary: {
		border: `1.5px solid ${COLORS.gold}`,
		borderRadius: 12,
		padding: "16px",
		backgroundColor: COLORS.warningLight,
		position: "relative",
	},
	conducteurBadge: {
		position: "absolute",
		top: -10,
		left: 16,
		backgroundColor: COLORS.gold,
		color: "#fff",
		fontSize: 10,
		fontWeight: 600,
		padding: "2px 10px",
		borderRadius: 99,
		letterSpacing: "0.06em",
		textTransform: "uppercase",
	},
	obsItem: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		padding: "10px 14px",
		border: `1px solid ${COLORS.border}`,
		borderRadius: 10,
		backgroundColor: COLORS.surface,
	},
	obsInput: {
		flex: 1,
		border: "none",
		outline: "none",
		fontSize: 13,
		color: COLORS.text,
		backgroundColor: "transparent",
		fontFamily: "inherit",
	},
	addBtn: {
		display: "flex",
		alignItems: "center",
		gap: 6,
		padding: "8px 14px",
		border: `1px dashed ${COLORS.borderStrong}`,
		borderRadius: 10,
		backgroundColor: "transparent",
		color: COLORS.textMuted,
		fontSize: 13,
		cursor: "pointer",
		fontFamily: "inherit",
		width: "100%",
		justifyContent: "center",
		transition: "all 0.15s",
	},
	footer: {
		display: "flex",
		justifyContent: "flex-end",
		gap: 10,
		marginTop: 24,
	},
	btnSecondary: {
		padding: "10px 20px",
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.surface,
		color: COLORS.text,
		fontSize: 14,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	},
	btnPrimary: {
		padding: "10px 24px",
		borderRadius: 10,
		border: "none",
		backgroundColor: COLORS.text,
		color: "#fff",
		fontSize: 14,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	},
}
